import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Share2 } from "lucide-react";
import axios from "axios";
import { BACKEND, media, fmtDate } from "@/lib/api";
import { Spin } from "@/components/common";

export default function SharePublic() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${BACKEND}/api/public/share/${token}`).then((r) => setD(r.data)).catch(() => setErr("Bu paylaşım bulunamadı veya kaldırıldı.")); }, [token]);
  return (
    <div className="min-h-screen bg-[var(--cream)]">
      <header className="px-8 py-4 border-b bg-white flex items-center gap-4"><div className="leading-none text-navy"><div className="font-serif-d text-3xl font-bold">ZOR</div><div className="font-serif-d text-xs">Dijital Yayınevi</div></div>
        {d && <button onClick={() => navigator.share ? navigator.share({ title: d.title, url: window.location.href }) : navigator.clipboard.writeText(window.location.href)} className="ml-auto btn-ghost px-4 py-2 flex items-center gap-2" data-testid="public-share-btn"><Share2 size={16} /> Paylaş</button>}</header>
      <main className="max-w-5xl mx-auto px-6 py-8 fade-up" data-testid="public-share-page">
        {err && <p className="text-center text-[#5f6f84] font-serif-d text-xl py-20" data-testid="public-share-error">{err}</p>}
        {!d && !err && <div className="grid place-items-center py-20 text-teal"><Spin size={28} /></div>}
        {d && <>
          <h1 className="font-serif-d text-4xl font-bold text-navy" data-testid="public-share-title">{d.title}</h1>
          <p className="text-[#5f6f84] mb-5">{d.book_title} • {fmtDate(d.created_at)}{d.kind === "pdf" ? ` • ${d.pages} sayfa` : ""}</p>
          {d.kind === "film" ? (
            <video src={media(d.url)} poster={media(d.cover)} controls className="w-full rounded-xl shadow-xl bg-black aspect-video" data-testid="public-film-player">{d.srt && <track kind="captions" srcLang="tr" label="Türkçe" src={media(d.srt)} />}</video>
          ) : <iframe title="PDF" src={media(d.url)} className="w-full h-[78vh] rounded-xl shadow-xl bg-white" data-testid="public-pdf-viewer" />}
          <a href={media(d.url)} download className="btn-teal inline-flex px-5 py-3 mt-5 items-center gap-2" data-testid="public-download-btn"><Download size={17} /> {d.kind === "film" ? "Filmi indir" : "PDF'i indir"}</a>
        </>}
      </main>
    </div>
  );
}
